export default function getCalendar(calendarId, calendars) {

  if (calendarId && calendars && calendars.length) {
    let thisCalendar;

    for (let index = 0; index < calendars.length; index++) {
      const element = calendars[index];

      if (element && calendarId === element.calendarId) {
        thisCalendar = element;
        break;
      }
      
    }
    return {
      calendarsList: thisCalendar,
    };

  }

  return {
    calendarsList: null
  };

}
